import topDestinations from '@config/topDestinations.json';

export const getTopDestinations = () => topDestinations;
